<script setup>
// No imports needed

import OrdersHeaderWrapper from './OrdersHeaderWrapper.vue';
import PaginationFooter from 'dashboard/components-next/pagination/PaginationFooter.vue';
import ActiveFilterPreview from 'dashboard/components-next/filter/ActiveFilterPreview.vue';

defineProps({
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, default: '' },
  showPaginationFooter: { type: Boolean, default: true },
  currentPage: { type: Number, default: 1 },
  totalItems: { type: Number, default: 100 },
  itemsPerPage: { type: Number, default: 15 },
  activeSort: { type: String, default: '' },
  activeOrdering: { type: String, default: '' },
  hasAppliedFilters: { type: Boolean, default: false },
  appliedFilters: { type: Array, default: () => [] },
});

const emit = defineEmits([
  'update:currentPage',
  'update:sort',
  'search',
  'applyFilter',
  'clearFilters',
  'openFilter',
  'openColumnConfig',
]);

const updateCurrentPage = page => {
  emit('update:currentPage', page);
};

const openFilter = () => emit('openFilter');
</script>

<template>
  <section
    class="flex w-full h-full gap-4 overflow-hidden justify-evenly bg-n-background"
  >
    <div class="flex flex-col w-full h-full transition-all duration-300">
      <OrdersHeaderWrapper
        :search-value="searchValue"
        :active-sort="activeSort"
        :active-ordering="activeOrdering"
        :header-title="headerTitle"
        :has-applied-filters="hasAppliedFilters"
        @update:sort="emit('update:sort', $event)"
        @search="emit('search', $event)"
        @apply-filter="emit('applyFilter', $event)"
        @clear-filters="emit('clearFilters')"
        @open-column-config="emit('openColumnConfig')"
      />
      <main class="flex-1 overflow-y-auto">
        <div class="w-full p-4">
          <ActiveFilterPreview
            v-if="hasAppliedFilters"
            :applied-filters="appliedFilters"
            :clear-button-label="$t('FILTER.CLEAR_BUTTON_LABEL')"
            :more-filters-label="$t('FILTER.MORE_FILTERS')"
            @clear-filters="emit('clearFilters')"
            @open-filter="openFilter"
          />
          <slot name="default" />
        </div>
      </main>
      <footer
        v-if="showPaginationFooter"
        class="sticky bottom-0 z-10 px-4 pb-4"
      >
        <PaginationFooter
          current-page-info="ORDERS_LAYOUT.PAGINATION_FOOTER.SHOWING"
          :current-page="currentPage"
          :total-items="totalItems"
          :items-per-page="itemsPerPage"
          @update:current-page="updateCurrentPage"
        />
      </footer>
    </div>
  </section>
</template>
